<script setup>
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import elasticAiConversations from "@/services/elastic-ai-conversations.service";
import CommonGrid from "../../../../../frontend/src/components/CommonGrid.vue";
import AiChatModal from "@/views/tools/usersSearches/AiElasticChatModal.vue";

const {items, gridParams, gridMethods} = useGrid(elasticAiConversations.getConversations);
const chatModal = ref(null);

const columns = [
    {
        label: 'Company Id',
        name: 'company_id',
        filter: 'text',
    },
    {
        label: 'Company Name',
        name: 'company_name',
        filter: 'text',
    },
    {
        label: 'Account Type',
        name: 'account_type',
    },
    {
        label: 'User',
        name: 'email',
        filter: 'text',
    },
    {
        label: 'Question',
        name: 'question',
        filter: 'text',
    },
    {
        label: 'Error',
        name: 'error_message',
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function gridAction(params) {
    if (params.action === 'view') {
        chatModal.value.open(params.rowId);
    }
}

</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <CommonGrid
                    :columns="columns"
                    :items="items"
                    :gridParams="gridParams"
                    :gridMethods="gridMethods"
                    :gridAction="gridAction"
                />
            </div>
        </div>

        <AiChatModal ref="chatModal"/>
    </div>
</template>

<style scoped>

</style>
